// extracted by mini-css-extract-plugin
module.exports = {"img_hovered":"ImgPreview_img_hovered__20W1X","img_disabled":"ImgPreview_img_disabled__2apnw","delete_icon":"ImgPreview_delete_icon__k6cqN"};